import { useIndexedDB } from "modules/db/hooks";
import { PreviousTestEntry } from "./types";

export const usePreviousTestsDB = () => useIndexedDB<PreviousTestEntry>("previous_tests");